import {gql} from "@apollo/client";
import {SiteType} from "graphql/types/SiteType";


export const GET_WAREHOUSES_FOR_HEADQUARTERS = gql`
  query GetWarehouses {
    warehouses: getWarehouseListForHeadquarters {
      id
      name
      siteType
      parentSiteId
    }
  }
`; 

export interface WarehousesResponse {
    warehouses: {
        id: string;
        name: string;
        siteType: SiteType;
        parentSiteId: string;
    }[];
}

export interface WarehouseType {
    id: string;
    name: string;
    siteType: SiteType;
    parentSiteId: string;
}